import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import CloseIconModal from "assets/icons/CloseIconModal";
import documentoEnviado from "../../assets/images/imgDocumentoEnviado.png";
import "./index.scss";

interface ModalExperienciaObrigadoProps {
  open: boolean;
  onClose: () => void;
  languageValues: any;
}

const ModalExperienciaObrigado: React.FC<ModalExperienciaObrigadoProps> = ({
  open,
  onClose,
  languageValues,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      closeAfterTransition
      disableEscapeKeyDown
      PaperProps={{
        className: 'ModalExperiencia_paper'
      }}
      style={{
        zIndex: 9999
      }}
    >
      <Box>
        <DialogTitle className='ModalExperiencia_dialogTitle'>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className='ModalExperiencia_titleModal'>
              {languageValues.modalAvisoGenericTitle}
            </Typography>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              size="small"
            >
              <CloseIconModal style={{ width: 'auto', height: 25 }} />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid item xs={12} style={{ marginTop: '25px' }}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  src={documentoEnviado}
                  alt="imagem-documento-enviado"
                  style={{ maxWidth: "300px", height: "225px" }}
                  draggable={false}
                />
              </Box>
            </Grid>

            <Grid item xs={12} style={{ marginTop: '25px' }}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <div className="ModalExperiencia_text-title-content-agradecimento">
                  {languageValues.modalExperiencia.agradecimento.title}
                </div>
              </Box>
            </Grid>

            <Grid item xs={12} style={{ marginBottom: '50px' }}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <div className="ModalExperiencia_text-content-agradecimento">
                  {languageValues.modalExperiencia.agradecimento.content1}
                </div>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <div className="ModalExperiencia_text-content-agradecimento">
                  {languageValues.modalExperiencia.agradecimento.content2}
                </div>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>

        <Container className='ModalExperiencia_dialogActions' disableGutters>
          <Box className="ModalExperiencia_container-box-btn">
            <div className="ModalExperiencia_btn">
              <Button
                className='ModalExperiencia_action-button-green'
                variant='contained'
                onClick={onClose}
                color="inherit"
              >
                {languageValues.modalExperiencia.buttons.fechar}
              </Button>
            </div>
          </Box>
        </Container>
      </Box>
    </Dialog>
  );
};

export default ModalExperienciaObrigado;
